import { ValidateJSModel } from 'forms/shared/types';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import nameModelValidator from 'forms/shared/validators/models/name/name';
import { setToStartOfMonth } from 'helpers/date';
import { MilitaryForeignItemContactModel } from '../types';

const militaryForeignContactValidator: ValidateJSModel<MilitaryForeignItemContactModel> = {
  Name: {
    presence: true,
    model: { validator: nameModelValidator },
  },

  Address: {
    presence: true,
    location: { validator: locationAddressModelValidator },
  },

  Title: {
    hasValue: true,
  },

  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Frequency: {
    hasValue: true,
  },
  Comments: {},
};

export default militaryForeignContactValidator;
